import type React from "react";
import { Box } from "@mui/material";
import type { IStreamDetails } from "../../../types/streams";
import type { CrewEntry } from "../components/callsheet/types/callsheet";
import QuickActionsPanel from "./sidebar/QuickActionsPanel";
import SharePanel from "./sidebar/SharePanel";
import AssignedCrewPanel from "./sidebar/AssignedCrewPanel";
import StreamProgramPanel from "./sidebar/StreamProgramPanel";
import ServiceDeliveryPanel from "./sidebar/ServiceDeliveryPanel";

interface StreamSidebarV2Props {
  stream: IStreamDetails;
  streamId?: number;
  crewMembersData: CrewEntry[];
  onCreateThumbnail: () => void;
  onCreateYouTubeLink: () => void;
  onSocialShare: (platform: "facebook" | "whatsapp") => void;
  onNavigateToMemorial: () => void;
}

const StreamSidebarV2: React.FC<StreamSidebarV2Props> = ({
  stream,
  streamId,
  crewMembersData,
  onCreateThumbnail,
  onCreateYouTubeLink,
  onSocialShare,
  onNavigateToMemorial,
}) => {
  const isFuneral = ["funeral", "funeralhome"].includes(
    stream.booking?.service?.toLowerCase().replace(/_/g, "") ?? "",
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <QuickActionsPanel
        stream={stream}
        streamId={streamId}
        onCreateThumbnail={onCreateThumbnail}
        onCreateYouTubeLink={onCreateYouTubeLink}
        onNavigateToMemorial={onNavigateToMemorial}
      />
      <SharePanel onSocialShare={onSocialShare} />
      <AssignedCrewPanel
        crewMembersData={crewMembersData}
        streamId={streamId}
      />
      <StreamProgramPanel streamId={streamId} />
      {isFuneral && <ServiceDeliveryPanel stream={stream} />}
    </Box>
  );
};

export default StreamSidebarV2;
